export default __webpack_public_path__ + "static/media/escape.84a5668e.svg";